<template>
  <div>
    <div class="d-flex align-items-center">
      <b-button @click="convertCsvToJson" size="sm" variant="info" class="mb-3">
        <font-awesome-icon icon="repeat" class="mr-1"></font-awesome-icon>
        Recarregar tabela
      </b-button>
      <b-button @click="validarDados" size="sm" variant="success" class="mb-3">
        <span>
          <font-awesome-icon :icon="status.icon" />
          {{ status.title }}
        </span>
      </b-button>

      <div class="ml-auto mb-2 pr-3 row text-uppercase">
        <div class="mr-1">
          <b-form-checkbox
            button
            v-model="apagar_emendas"
            :button-variant="apagar_emendas ? 'bagsis' : ''"
            size="sm"
            class="rounded-pill cursor-pointer"
          >
            <b-icon
              :icon="apagar_emendas ? 'check-circle-fill' : 'circle'"
              class="mr-1"
            ></b-icon>
            Alterar todas as emendas
          </b-form-checkbox>
        </div>
        <div class="mr-1">
          <b-form-checkbox
            button
            v-model="apagar_beneficios"
            :button-variant="apagar_beneficios ? 'bagsis' : ''"
            size="sm"
            class="rounded-pill cursor-pointer"
          >
            <b-icon
              :icon="apagar_beneficios ? 'check-circle-fill' : 'circle'"
              class="mr-1"
            ></b-icon>
            Alterar todos os recursos especifícos
          </b-form-checkbox>
        </div>
        <div>
          <b-button v-b-toggle.filter-collapse variant="bagsis" size="sm">
            <b-icon icon="filter"></b-icon>
            Filtros
          </b-button>
        </div>
      </div>
    </div>
    <b-collapse id="filter-collapse" class="mt-2">
      <b-card horizontal>
        <b-list-group flush>
          <b-list-group-item>
            <small class="card-text text-uppercase text-gray">
              Filtrar por:
            </small>
          </b-list-group-item>
          <b-list-group-item
            v-for="(value, key) in rowFilters"
            :key="'filter_field_' + key"
          >
            <b-form-checkbox v-model="rowFilters[key]">
              {{ dictionaryFilters[key] }}
            </b-form-checkbox>
          </b-list-group-item>
        </b-list-group>
      </b-card>
    </b-collapse>
    <div class="col-12 my-3" v-show="hasActiveFilter">
      <h4 class="h5">Filtros ativos</h4>
      <div class="row col-12">
        <small v-for="(filter, key) in rowFilters" :key="'filter_tag_' + key">
          <b-badge variant="bagsis" pill v-if="filter">
            {{ dictionaryFilters[key] }}
          </b-badge>
        </small>
      </div>
    </div>

    <div class="d-block" v-if="count_validations > 0">
      <b-progress
        :max="pagination.total"
        height="1.5rem"
        variant="info"
        striped
        animated
        v-show="progressLabel !== '100'"
      >
        <b-progress-bar
          :value="count_validations"
          :label="progressLabel + '%'"
        ></b-progress-bar>
      </b-progress>

      <b-alert
        variant="warning"
        show
        dismissible
        v-if="count_errors > 0"
        class="d-flex align-items-start"
      >
        <b-icon icon="exclamation-triangle-fill" class="mr-3 mt-1" />
        <div class="d-block">
          <h5 class="text-white">Alguns erros foram encontrados</h5>
          {{ errorMessage }}
        </div>
      </b-alert>
      <b-alert
        variant="success"
        show
        v-else-if="count_validations == pagination.total"
      >
        <font-awesome-icon icon="clipboard-check" />
        Validação sem erros...
      </b-alert>
    </div>

    <b-table
      responsive
      striped
      hover
      :items="items"
      :fields="header"
      :busy="
        count_validations > 0 ? parseInt(progressLabel || 100) < 100 : loading
      "
      :currentPage="pagination.currentPage"
      :perPage="pagination.perPage"
      show-empty
      :class="{ 'table-height-current': items.length > 0 }"
      thead-class="shadow-lg"
      ref="file-data-table"
    >
      <template #cell(registros)="{ item }">
        {{ item.registros }} registros
        <span class="d-block" v-if="item.tipos.emendas !== null">
          {{ item.tipos.emendas }} emendas parlamentares
        </span>
        <span class="d-block" v-if="item.tipos.beneficios !== null">
          {{ item.tipos.beneficios }} específicos do concendente
        </span>
      </template>
      <template #cell(info)="{ item }">
        <b-button @click="open_item(item)" class="btn-item-info" variant="info"
          ><font-awesome-icon icon="info-circle"
        /></b-button>
      </template>

      <template #cell(importados)="{ item }">
        {{ item.importados }}
        <small v-if="typeof item.importados === 'number'" class="text-muted">
          ({{ Math.round((100 * item.importados) / item.registros) }}%)
        </small>
      </template>

      <template #cell(erros)="{ item }">
        <span v-if="item.erros === null">--</span>
        <span v-else-if="item.erros.length === 0">
          <font-awesome-icon
            icon="circle-check"
            class="text-success"
            style="font-size: 1.1rem"
          />
        </span>
        <span
          v-for="(error, key) in item.erros"
          :key="'error-' + key"
          class="d-block"
        >
          <font-awesome-icon icon="circle-exclamation" class="text-warning" />
          {{ error }}
        </span>
      </template>

      <template #cell(apagar-emendas)="{ item }">
        <b-form-checkbox v-model="item.apagar_emendas" />
      </template>

      <template #cell(apagar-beneficios)="{ item }">
        <b-form-checkbox v-model="item.apagar_beneficios" />
      </template>

      <template #table-busy>
        <div class="text-center text-exitos my-2">
          <b-spinner class="align-middle mr-3"></b-spinner>
          <strong>Carregando...</strong>
        </div>
      </template>
      <template #empty="{}">
        <h5 class="h5 text-center font-weight-normal">
          Nenhum registro para o filtro especificado. Verifique o arquivo ou
          altere as configurações.
        </h5>
      </template>
    </b-table>

    <b-row class="mt-4" v-if="data_array.length > 0">
      <b-col>
        <pagination v-model="pagination" />
      </b-col>

      <b-col>
        <b-form-group
          label="Exibir"
          label-cols="8"
          label-align="right"
          label-size="sm"
        >
          <b-form-select
            v-model="pagination.perPage"
            :options="pageOptions"
            size="sm"
          ></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>

    <b-modal
      id="modal-item-info"
      size="xl"
      :title="item_info.id"
      cancel-title="Cancelar"
      ok-variant="bagsis"
    >
      <table-item-children :item="item_info" />
    </b-modal>
  </div>
</template>

<script>
import TableItemChildren from "./TableItemChildren.vue";
import * as csv from "csvtojson";
import _ from "lodash";
import textToNumber from "@/helpers/functions/textToNumber";
import { mapActions } from "vuex";

export default {
  components: { TableItemChildren },
  props: {
    file_data: {
      type: String,
    },
    delimiter: {
      type: String,
      default: ",",
    },
    quote: {
      type: String,
      default: '"',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    config_columns: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    itens: [],

    rowFilters: {
      byError: false,
    },

    data_array: [],
    pagination: {
      currentPage: 1,
      perPage: 10,
      total: 0,
    },
    pagination_item: {
      currentPage: 1,
      perPage: 10,
    },
    count_validations: 0,
    count_errors: 0,
    apagar_emendas: false,
    apagar_beneficios: false,

    sortBy: "",
    sortDesc: false,

    item_info: {},
    statusValidacao: "iniciar",
  }),
  computed: {
    pageOptions() {
      return [10, 50, 100, { value: this.pagination.total, text: "Todos" }];
    },
    csv_options() {
      return {
        output: "json",
        delimiter: this.delimiter,
        quote: this.quote,
      };
    },
    id() {
      const indexConfig = this.indexConfig("codigo");
      const field = this.fields[indexConfig];

      if (!field) {
        return "";
      }

      return this.fields[indexConfig].key;
    },
    header() {
      return [
        { key: "id", label: "Código da Oportunidade", sortable: true },
        { key: "registros", class: "col-2", sortable: true },
        { key: "importados", class: "col-1" },
        {
          key: "erros",
          label: "Status",
          class: "col-2",
          sortable: true,
        },
        { key: "apagar-emendas", label: "Apagar Emendas", class: "col-1" },
        {
          key: "apagar-beneficios",
          label: "Apagar Recursos Específicos",
          class: "col-1",
        },
        { key: "info", label: "Informações da Importação", class: "col-1" },
      ];
    },
    fields() {
      const fields = [];
      if (this.data_array && Array.isArray(this.data_array)) {
        if (this.data_array.length === 0) return;

        for (const key of Object.keys(this.data_array[0])) {
          fields.push({ key: key, sortable: true });
        }
      }
      return fields;
    },
    indexes() {
      return [
        this.fields[this.indexConfig("codigo")].key,
        this.fields[this.indexConfig("emenda")].key,
        this.fields[this.indexConfig("parlamentar")].key,
        this.fields[this.indexConfig("cnpj")].key,
        this.fields[this.indexConfig("beneficiario")].key,
        this.fields[this.indexConfig("repasse")].key,
      ];
    },
    status() {
      switch (String(this.statusValidacao).toLowerCase()) {
        case "iniciar":
          return { title: "Iniciar Validação", icon: "play" };

        case "parada":
          return { title: "Validação Parada", icon: "pause" };

        case "validando":
          return { title: "Validando Dados", icon: "spinner", spin: true };

        case "finalizada":
          return { title: "Validação Finalizada", icon: "list-check" };
      }
    },
    errorMessage() {
      return this.count_errors > 1
        ? `Foram encontrados ${this.count_errors} erros na validação do arquivo`
        : `Foi encontrado ${this.count_errors} erro na validação do arquivo`;
    },
    progressLabel() {
      if (!this.count_validations) {
        return 0;
      }
      if (!this.pagination.total) {
        return 0;
      }

      return ((this.count_validations / this.pagination.total) * 100).toFixed(
        0
      );
    },
    dictionaryFilters() {
      return {
        byError: "Erro",
      };
    },
    hasActiveFilter() {
      if (typeof this.rowFilters !== "object") {
        return false;
      }
      return Object.keys(this.rowFilters).some(
        (filter) => this.rowFilters[filter]
      );
    },
    items() {
      if (this.hasActiveFilter) {
        const sourceItems = this.itens;

        const filterSourceItem = (item) => {
          for (const filterKey in this.rowFilters) {
            switch (filterKey) {
              case "byError":
                return (
                  this.rowFilters[filterKey] &&
                  item.erros &&
                  Array.isArray(item.erros) &&
                  item.erros.length > 0
                );

              default:
                break;
            }
          }
        };

        return sourceItems.filter(filterSourceItem);
      }

      return this.itens;
    },
  },
  methods: {
    ...mapActions("oportunidades", ["ActionValidarEmendas"]),
    validarDados() {
      if (this.statusValidacao == "validando") {
        this.statusValidacao = "parada";
      } else {
        this.statusValidacao = "validando";
        this.$nextTick(() => {
          this.startValidacao();
        });
      }
    },
    async startValidacao() {
      if (this.statusValidacao == "validando") {
        let index = _.findIndex(this.itens, { erros: null });
        if (index == -1) {
          this.statusValidacao = "finalizada";
        } else {
          try {
            let perValidation = Math.ceil(this.pagination.total / 20);
            let itenToValidate = [];
            for (let i = 0; i < perValidation; i++) {
              if (index + i < this.pagination.total) {
                itenToValidate.push(this.itens[index + i]);
              }
            }

            const itens = this.itens;
            const validation = await this.ActionValidarEmendas(itenToValidate);
            validation.forEach((item, key) => {
              itens[key + index] = item;
              this.count_validations++;

              if (item.erros.length) {
                this.count_errors++;
              }
            });

            this.$nextTick(() => {
              this.setItens(itens);
              this.startValidacao();
            });
          } catch (error) {
            console.log("error", error);
            this.statusValidacao = "parada";

            const error_message = "Erro ao executar validação";
            this.$notifications.addNotification({
              message: error_message,
              type: "danger",
            });
          }
        }
      }
    },

    async convertCsvToJson() {
      this.statusValidacao = "iniciar";
      this.count_validations = 0;
      this.count_errors = 0;
      if (!this.file_data) return;
      try {
        const response = await csv(this.csv_options).fromString(this.file_data);
        this.data_array = response;
      } catch (err) {
        this.data_array = [];
      }

      this.formatItens();
      this.$emit("loaded");
    },
    setItens(itens) {
      this.itens = itens;
      this.pagination.total = this.items.length;

      if (this.$refs["file-data-table"]) {
        this.$refs["file-data-table"].refresh();
      }
    },
    formatItens() {
      let itens = {};

      if (this.fields && Array.isArray(this.fields) && this.fields[0]) {
        try {
          for (const values of this.data_array) {
            const index = values[this.id];

            if (!itens[index]) {
              itens[index] = {
                id: index,
                registros: 0,
                tipos: {
                  emendas: null,
                  beneficios: null,
                },
                apagar_emendas: false,
                apagar_beneficios: false,
                importados: "--",
                erros: null,
                children: [],
              };
            }

            const new_values = {
              codigo: values[this.indexes[0]],
              emenda: values[this.indexes[1]],
              parlamentar: values[this.indexes[2]],
              cnpj: values[this.indexes[3]],
              beneficiario: values[this.indexes[4]],
              repasse: textToNumber(values[this.indexes[5]]),
              info: "Não importado",
            };

            itens[index].children.push(new_values);
            itens[index].registros++;
          }
        } catch (error) {
          itens = {};
          this.$notifications.addNotification({
            message:
              "Erro ao converter dados. <br/> Tente alterar as configurações do delimitador",
            icon: "exclamation-triangle",
            type: "danger",
          });
        }
      }
      this.setItens(_.values(itens));
    },
    open_item(item) {
      this.item_info = item;
      this.pagination_item = {
        currentPage: 1,
        perPage: 10,
      };
      this.$bvModal.show("modal-item-info");
    },
    indexConfig(index) {
      return this.config_columns.indexOf(index);
    },
    setValueInColItem(key, value) {
      for (const colItem of this.items) {
        colItem[key] = value;
      }
    },
  },
  watch: {
    file_data: {
      deep: true,
      handler: function () {
        this.convertCsvToJson();
      },
    },
    delimiter: function () {
      this.convertCsvToJson();
    },
    quote: function () {
      this.convertCsvToJson();
    },
    statusValidacao: function (value) {
      this.$emit("statusValidacao", value);
    },
    apagar_emendas: function (value) {
      this.setValueInColItem("apagar_emendas", value);
    },
    apagar_beneficios: function (value) {
      this.setValueInColItem("apagar_beneficios", value);
    },
  },
  created() {
    this.convertCsvToJson();
  },
};
</script>

<style lang="scss">
.btn-item-info {
  border-radius: 50%;
  width: 30px;
  height: 30px;
  padding: 0 !important;

  font-size: 1rem;
  padding: auto !important;

  display: flex;
  align-items: center;
  justify-content: center;
}

.cursor-pointer {
  cursor: pointer !important;
  & label {
    cursor: pointer !important;
  }
}

.table-height-current {
  height: 100vh;
  max-height: calc(100vh - 76px);
  & thead {
    position: sticky;
    z-index: 1;
    background-color: #fff;
    top: -2px;
    left: 0;
    right: 0;
  }
}
</style>
